import * as API from '../../requests'
import ActiveRecord from './active_record/base'

const MAX_PDF_SIZE = 50000000 // 50 MB
const validateFileSize = file => {
	if (file?.[0]?.size >= MAX_PDF_SIZE) return {ok: false, error: true, message: 'pdf_size_exceeded'}
}

class Info extends ActiveRecord {
	static tableName = 'infos'
	static sort = {field: 'general_order', direction: 'desc'}

	constructor(props) {
		super(props)
		this.searchable_content = props.content.replace(/<[^>]+>/g, '')
	}

	static async create({file, ...data}, opts) {
		const fileError = validateFileSize(file)
		if (fileError) {
			await this.modelConfig?.createOnError?.(fileError)
			return fileError
		}

		const res = await super.create(data, opts)

		// we need an article id to add the pdf content, therefore this two-stage rocket
		if (res.item && file) {
			await API.updateAsset(this.tableName, res.item.id, file)
		}

		return res
	}

	async updateAsset(file) {
		return await API.updateAsset(this.tableName, this.id, file)
	}

	async publish() {
		return await super.update({published: true})
	}

	async unpublish() {
		return await super.update({published: false})
	}

	async addAttachment(data) {
		return await API.attach(this.tableName, this.id, data)
	}

	async addPdfContent(data) {
		const fileError = validateFileSize(data)
		if (fileError) {
			await this.modelConfig?.createOnError?.(fileError)
			return fileError
		}
		return await API.updateAsset(this.tableName, this.id, data)
	}

	async removeAttachment(index) {
		return await API.removeAttachment(this.tableName, this.id, index)
	}

	async updateReadCount() {
		return await API.arbitrary(this.tableName, `${this.tableName}/${this.id}/read`, {extraParams: {doNotLoad: true}})
	}

	async toggleLike() {
		return await API.toggle(this.tableName, {field: 'likers', id: this.id})
	}
}

export default Info
